import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

/**
 * Reusable "Are you sure?" confirmation for the lower-risk permanent
 * deletes (Files/Presentations/Library items — always already
 * archived by this point — and individual Contract/Invoice/Payment
 * records). Never used for Client or Engagement deletion, which needs
 * the stronger type-to-confirm dialog instead.
 */
export function SimpleDeleteConfirm({ open, onOpenChange, title, description, onConfirm, isPending, testId }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId || "simple-delete-confirm-dialog"}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="simple-delete-confirm-cancel">Cancel</AlertDialogCancel>
          <Button
            variant="destructive" disabled={isPending} onClick={onConfirm}
            data-testid="simple-delete-confirm-submit"
          >
            {isPending ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : null}
            Delete permanently
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
